import { Button, Card, CardContent, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import { getScreenRight } from "utils/generic";
import TimelineItem from "components/Icon/TimelineItem";
import { useMaterialUIController } from "context";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import { useDispatch } from "react-redux";
import { fetchTemplate } from "utils/superAdminApi";
import { BTable } from "components/BTable/BTable";
import { GridSearchIcon } from "@mui/x-data-grid";
import PageTitle from "examples/PageTitle/PageTitle";


let searchParameter = "";
let templateStatus = "All";
let LOGIN_DETAILS;

function Templates() {

  const [customerReload, setCustomerReload] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [rows, setRows] = useState([]);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  // eslint-disable-next-line no-unused-vars
  const [title, setTitle] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const dispatch = useDispatch();
  const [values, setValues] = React.useState({
    _id: [],
    userType: "",
    sortingType: "",
    sortingField: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    searchParameter: "",
    templateStatus: "All",
    searchParameterList: ["templateName", "templateType", "templateStatus"],
    businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID,

  });

  if (sessionStorage.getItem('LOGIN_DETAILS') !== undefined && sessionStorage.getItem('LOGIN_DETAILS') != null) {
    LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
    values.businessUserID = LOGIN_DETAILS.businessUserID;
  }

  useEffect(() => {
    (async () => {
      await getRight();
      await fetchUserData();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.templateStatus, values.sortingType, perPage, dispatch]);

  useEffect(() => {
    if (values.filterValues.length == "") {
      fetchUserData();
    }
  }, [values.filterValues]);

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = page => {
    values.page = page;
    fetchUserData();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const changeCustomerReload = () => {
    setCustomerReload(!customerReload);
  };

  async function getRight() {
    let right = await getScreenRight("Templates")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(true)
  }

  useEffect(() => {
    templateStatus = values.templateStatus;
    changeCustomerReload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.templateStatus]);

  const fetchUserData = async () => {
    values.searchParameter = searchParameter;
    values.templateStatus = templateStatus;
    await fetchTemplate(values, (data) => {
      setTotalRows(data.Result_Output.totalDocs);
      setRows(data.Result_Output.docs)
    }, dispatch)
  };

  let columns = [
    {
      name: "Template Name",
      selector: row => row.templateName,
      sortable: true,
      sortField: 'templateName',
    },
    {
      name: "Template Type",
      selector: row => row.templateType,
      sortable: true,
      sortField: 'templateType',
      center: true,
    },
    {
      // name: "Status",
      name: <p style={{ paddingLeft: "12px" }}>Status</p>,
      selector: row => row.templateStatus,
      sortable: true,
      sortField: 'templateStatus',
      center: true,
    },

    {
      name: "Actions",
      selector: row => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>
            <Grid item>
              <Link
                to={`/templates/edit/${row._id}`}
              >
                <TimelineItem color="success" icon="edit" title="Edit" />
              </Link>
            </Grid>
          </Grid>
        </>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="Templates" />
          <Grid container display={"flex"} justifyContent="end" mt={2.2} gap={2} >
            <Grid lg={2.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "44.11px" }}
                  label="Filter By Status"
                  value={values.templateStatus}
                  onChange={(e) => setValues({ ...values, templateStatus: e.target.value })} >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchUserData();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchUserData}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: '16px' }}>
              <Link to={"/templates/new"}>
                <MDButton
                  variant="contained"
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                  color={disableColor ? "secondary" : "success"} style={{ height: "44.11px", width: "99px" }}>
                  Add New
                </MDButton>
              </Link>
            </div>
          </Grid>
          <CardContent>
            <BTable
              title={title}
              columns={columns}
              data={rows}
              selectableRows={false}
              sortingType={handleSort}
              sortServer
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}

              fixedHeaderScrollHeight="410px"
              fixedHeader={true}
            />
          </CardContent>
        </Card>
      </div >


    </DashboardLayout>
  );
}

export default Templates;
